module.exports = __webpack_public_path__ + "img/categorie-coffret-famille-boutrais-big.d0719ac3.jpg";